import React from "react";
import { Phone, MapPin } from "lucide-react";
import { LegalLayout, LegalH2, LegalP } from "../components/landing/LegalLayout";
import { useLang } from "../i18n/LanguageContext";

const content = {
  de: {
    title: "Impressum",
    subtitle: "Angaben gemäss den gesetzlichen Vorgaben.",
    provider: "Anbieterin",
    brand: "WasGitsHüt? ist eine Marke der Liberox GmbH.",
    repTitle: "Vertretungsberechtigte Person",
    rep: "Nikson Karrica – Inhaber und Geschäftsführer",
    contact: "Kontakt",
    disclaimerTitle: "Haftungsausschluss",
    disclaimer:
      "Die Inhalte dieser Website wurden mit grösstmöglicher Sorgfalt erstellt. Für die Richtigkeit, Vollständigkeit und Aktualität der Inhalte übernimmt die Liberox GmbH jedoch keine Gewähr. Für Inhalte externer Links sind ausschliesslich deren Betreiber verantwortlich.",
    copyrightTitle: "Urheberrecht",
    copyright:
      "Alle Inhalte dieser Website (Texte, Bilder, Logo, Gestaltung) sind urheberrechtlich geschützt. Eine Verwendung ausserhalb der Grenzen des Urheberrechts bedarf der schriftlichen Zustimmung der Liberox GmbH.",
    country: "Schweiz"
  },
  en: {
    title: "Imprint",
    subtitle: "Information according to legal requirements.",
    provider: "Provider",
    brand: "WasGitsHüt? is a brand of Liberox GmbH.",
    repTitle: "Authorised representative",
    rep: "Nikson Karrica – owner and managing director",
    contact: "Contact",
    disclaimerTitle: "Disclaimer",
    disclaimer:
      "The contents of this website have been created with the greatest possible care. However, Liberox GmbH assumes no liability for the accuracy, completeness and timeliness of the contents. The operators of external links are solely responsible for their contents.",
    copyrightTitle: "Copyright",
    copyright:
      "All contents of this website (texts, images, logo, design) are protected by copyright. Any use beyond the limits of copyright requires the written consent of Liberox GmbH.",
    country: "Switzerland"
  }
};

export default function Impressum() {
  const { lang } = useLang();
  const c = content[lang] || content.de;
  return (
    <LegalLayout testId="page-impressum" title={c.title} subtitle={c.subtitle}>
      <LegalH2>{c.provider}</LegalH2>
      <div className="mt-4 space-y-4 text-petrol-soft">
        <p className="flex items-start gap-3">
          <MapPin className="mt-0.5 h-5 w-5 shrink-0 text-terracotta" />
          <span>
            <span className="font-semibold text-petrol">Liberox GmbH</span>
            <br />
            Bodenäckerstrasse 3
            <br />
            8957 Spreitenbach
            <br />
            {c.country}
          </span>
        </p>
        <p>{c.brand}</p>
      </div>

      <LegalH2>{c.repTitle}</LegalH2>
      <LegalP>{c.rep}</LegalP>

      <LegalH2>{c.contact}</LegalH2>
      <div className="mt-4 space-y-3">
        <a
          href="tel:+41565616762"
          data-testid="impressum-phone-link"
          className="flex items-center gap-3 font-semibold text-petrol transition-colors duration-200 hover:text-terracotta"
        >
          <Phone className="h-5 w-5 text-terracotta" />
          056 561 67 62
        </a>
      </div>

      <LegalH2>{c.disclaimerTitle}</LegalH2>
      <LegalP>{c.disclaimer}</LegalP>

      <LegalH2>{c.copyrightTitle}</LegalH2>
      <LegalP>{c.copyright}</LegalP>
    </LegalLayout>
  );
}
